export default {
  icon_text: 'Gesloten',
  buttons: {
    ok: 'Ok',
  },
};
